/**
 * Created by Jie Gao on 2018-11-14.
 */
import {SpinController} from "@nolimitcity/slot-game/bin/core/spin/SpinController";
import {ZeroBetManager} from "@nolimitcity/slot-game/bin/core/zerobet/ZeroBetManager";
import {ScreenManager} from "@nolimitcity/slot-game/bin/core/screen/ScreenManager";
import {StarStruckParsedGameData} from "../server/data/StarStruckParsedGameData";

export class StarStruckSpinController extends SpinController {
    private _nearWinReels:boolean[] = [false, false, false];

    constructor() {
        super();
    }

    protected parseGameData(data:StarStruckParsedGameData):void {
        this._nearWinReels = [false, false, false];
        if(data.nearWinReels){
            this._nearWinReels = data.nearWinReels;
        }
    }

    protected getSpinTime():number {
        if(this._nearWinReels[0]) {
            return 0.1;
        } else {
            return super.getSpinTime();
        }
    }
}